import { render } from "./CaricaConsumiFile.vue?vue&type=template&id=17476890&scoped=true"
import script from "./CaricaConsumiFile.vue?vue&type=script&lang=js"
export * from "./CaricaConsumiFile.vue?vue&type=script&lang=js"

import "./CaricaConsumiFile.vue?vue&type=style&index=0&id=17476890&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17476890"]])

export default __exports__